import '@module/SeoFaq/SeoFaq.scss';
import { addEventListeners, documentReady, qs, qsa, slideToggle } from '@utils/toolbox';

documentReady(() => {
	addEventListeners(qsa('[data-faq-item]'), 'click', (item) => {
		// If item is a anchor tag do not toggle the faq item
		if (item.target.tagName === 'A') {
			return;
		}
		const parent = item.target.closest('[data-faq-item]');
		parent.classList.toggle('open');
		slideToggle(qs('.faq-answer', parent));
	});
});
